import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { IClientCompanyDropdown } from "../../models/IDropdown";
import { Fetch } from "../../shared/Fetch";
import { PrimeVendorLegalDocument } from "./PrimeVendorLegalDocument";
import { Dropdown } from 'primereact/dropdown';
import { Card } from "primereact/card";
import { SubVendorLegalDocument } from "./SubVendorLegalDocument";


export const LeagalDocument = () => {
    const [vendorCompany, setVendorCompany] = useState<any | null>(null);
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>([]);
    const [vendorCompanies, setVendorCompanies] = useState<Array<IClientCompanyDropdown>>([]);
    const [loading, setLoading] = useState(false);
    const [activeVendor, setActiveVendor] = useState<string>("Prime Vendor");

    // 

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }

    const loadVendorCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/sub_vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setVendorCompanies(data);
        }
    }

    const search = (event: { query: string }) => {
        if ((event.query).trim().length >= 1) {
            loadClientCompanies(event.query);
            // setVendorCompany(null);
        }
    }

    const searchSub = (event: { query: string }) => {
        if ((event.query).trim().length >= 1) {
            loadVendorCompanies(event.query);
            // setVendorCompany(null);
        }
    }

    const clear = () => {
        setVendorCompany(null);
        setClientCompanies([]);
        setVendorCompanies([]);
    }

    useEffect(() => {
        if (vendorCompany !== undefined && vendorCompany != null && vendorCompany.vendor_Company_ID !== undefined && vendorCompany.vendor_Company_ID !== null && vendorCompany.vendor_Company_ID > 0) {
            setVendorCompany(null);
            setVendorCompanies([]);
        }
    }, [activeVendor]);
    // { && 

    return (
        <Card>
            <div className="p-fluid formgrid grid">
                <div className="col-12 md:col-2">
                    <Dropdown value={activeVendor} onChange={(e: any) => setActiveVendor(e.value)} options={[{ name: "Prime Vendor" }, { name: "Sub Vendor" }]} optionLabel="name" optionValue="name" placeholder="Select Vendor Type" className="w-full " />
                </div>
                <div className="col-12 md:col-10 flex gap-4">
                    {activeVendor === "Prime Vendor" && <AutoComplete className="w-full" value={vendorCompany} suggestions={clientCompanies} completeMethod={search} field="vendor_Company_Name" placeholder="Search Client/Company" onChange={(e) => setVendorCompany(e.value)} />}
                    {activeVendor === "Sub Vendor" && <AutoComplete className="w-full" value={vendorCompany} suggestions={vendorCompanies} completeMethod={searchSub} field="vendor_Company_Name" placeholder="Search Vendor/Company" onChange={(e) => setVendorCompany(e.value)} />}
                    <Button style={{ width: "6rem" }} label={loading === true ? "LOADING..." : "CLEAR"} loading={loading} disabled={loading} onClick={clear}></Button>
                </div>
            </div>
            {activeVendor === "Prime Vendor" && (vendorCompany !== undefined && vendorCompany != null && vendorCompany.vendor_Company_ID !== undefined && vendorCompany.vendor_Company_ID !== null && vendorCompany.vendor_Company_ID > 0) && <PrimeVendorLegalDocument vendorCompany={vendorCompany} />}
            {activeVendor === "Sub Vendor" && (vendorCompany !== undefined && vendorCompany != null && vendorCompany.vendor_Company_ID !== undefined && vendorCompany.vendor_Company_ID !== null && vendorCompany.vendor_Company_ID > 0) && <SubVendorLegalDocument vendorCompany={vendorCompany} />}
        </Card>
    );
}